import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTopOnReload } from "./utils/scroll.util";
import Layout from "./utils/layout.util";
import ErrorInfo from "./pages/errorInfo.page";
import HomePage from "./pages/home.page";
import ImprintPage from "./pages/imprint.page";
import PrivacyPage from "./pages/privacy.page";
import VotingDetailPage from "./pages/votingDetail.page";
import BusinessCasePage from "./pages/businessCase.page";
import AdminPage from "./pages/admin.page";
import WinnersPage from "./pages/winners.page";
import { LanguageProvider } from "./i18n/language.context";
import GlobalLanguageSwitcher from "./components/languageSwitcher.component";
// Do not change order of CSS imports
// general
import "./App.css";
import "./styles/layout.style.css";
import "./styles/general.style.css";
import "./styles/text.style.css";
import "./styles/general.style.css";
import "./styles/text.style.css";
import "./styles/button.style.css";
import "./styles/colors.style.css";
import "./styles/colors.style.css";
// Default overwrites
import "./styles/mobile.style.css";

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <ScrollToTopOnReload />
                <GlobalLanguageSwitcher />
                <Routes>
                    {/* General */}
                    <Route path={``} element={Layout({ page: <HomePage />, header: false, footer: true, background: {} })} />
                    <Route path={`/imprint`} element={Layout({ page: <ImprintPage />, header: false, footer: true, background: {} })} />
                    <Route path={`/privacy`} element={Layout({ page: <PrivacyPage />, header: false, footer: true, background: {} })} />
                    <Route path={`/voting/:slug`} element={Layout({ page: <VotingDetailPage />, header: false, footer: true, background: {} })} />
                    <Route path={`/business-case`} element={Layout({ page: <BusinessCasePage />, header: false, footer: true })} />
                    <Route path={`/admin`} element={Layout({ page: <AdminPage />, header: false, footer: false, background: {} })} />
                    <Route path={`/winners`} element={Layout({ page: <WinnersPage />, header: true, footer: true, background: {} })} />
                    <Route path={`/winners/:slug`} element={Layout({ page: <WinnersPage />, header: true, footer: true, background: {} })} />
                    {/* Error pages */}
                    <Route path={`*`} element={Layout({ page: <ErrorInfo />, header: false, footer: true, background: {} })} /> {/* 404 Page not found */}
                    <Route path={`/error`} element={Layout({ page: <ErrorInfo />, header: false, footer: true, background: {} })} />
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}
export default App;